import { isScriptAdded } from '@/public/functions';


const chiliPiperPixel = (router, userData) => {
    console.log('Execute Chili Piper pixel');
    ChiliPiper.submit("ooma", router, {
        map: true,
        lead: userData,
        debug: true
    })
}


export const chiliPiper = (uri, currentForm, userData) => {
    if ($('button', currentForm).hasClass('schedule-a-consultation')) {
        //check if the chili piper script is added.
        if (isScriptAdded('https://js.chilipiper.com/marketing.js')) {
            let routerName = 'live_calls'
            if (uri.includes('/airdial') || uri.includes('/es/')) {
                routerName = 'inbound_router';
            }
            chiliPiperPixel(routerName, userData);
        } else {
            console.log('Chili Piper script is not added');
        }

    }

}

